export default __webpack_public_path__ + "static/media/snowflake.8bf71d4f.svg";